import React, { useState } from 'react';
import HelpApiNavbar from './HelpApiNavbar';
import HelpApiFooter from './HelpApiFooter';
import './HelpApiLayout.css';

/**
 * HelpApiLayout Component
 * Specialized layout for Help Center and API Documentation pages
 * Includes custom navbar, sidebar, main content, right placeholder, and footer
 */
const HelpApiLayout = ({ 
  children, 
  className = '',
  sidebar,
  type = 'help' // 'help' or 'api'
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSidebarClick = () => {
    // Close menu when clicking on sidebar links on mobile
    if (window.innerWidth <= 968) {
      setIsMenuOpen(false);
    }
  };

  return (
    <div className={`help-api-layout ${className} ${type}-layout ${isMenuOpen ? 'menu-open' : ''}`}>
      <HelpApiNavbar 
        type={type} 
        onMenuToggle={handleMenuToggle}
        isMenuOpen={isMenuOpen}
      />
      <div className="help-api-layout-body">
        <aside className={`help-api-sidebar ${isMenuOpen ? 'mobile-open' : ''}`} onClick={handleSidebarClick}>
          {sidebar}
        </aside>
        <main className="help-api-main">
          {children}
        </main>
        <aside className="help-api-placeholder">
          {/* Placeholder block of same size as sidebar */}
        </aside>
      </div>
      {/* Mobile overlay when menu is open */}
      {isMenuOpen && (
        <div 
          className="help-api-mobile-overlay"
          onClick={handleMenuToggle}
          aria-hidden="true"
        />
      )}
      <HelpApiFooter />
    </div>
  );
};

export default HelpApiLayout;
